import { GuaranteeApplication } from '../models/guarantee-application.interface';
import { Prescription, PrescriptionTypes, PrescriptionHistoryStatus } from '../models/prescription.interface';
import { PrescriptionsDraftsState } from './prescriptions-drafts.state';

export interface PrescriptionsFeatureState {
  prescriptions: PrescriptionsState;
  drafts: PrescriptionsDraftsState;
}

export interface PrescriptionsState {
  prescriptionSubmitted: boolean;
  prescriptionDraftSubmitted: boolean;
  prescriptionSaved: boolean;
  prescriptionEdited: Prescription | null;
  prescriptionDeleted: { id: string; type: PrescriptionTypes } | null;
  initRequired: boolean;
  guaranteesFilters: PrescriptionsFilters;
  targetPrescription: { prescriptionId: string } | null;
  count: number;
  page: number;
  pageSize: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  guarantees: GuaranteeApplication[];
  draftsProcessing: boolean;
  loading: boolean;
  guaranteesFetching: boolean;
}

export enum PrescriptionTypeFilters {
  All = 'All',
  Drugs = 'Drugs',
  RelatedSpecialists = 'RelatedSpecialists',
  InstrumentalDiagnostic = 'InstrumentalDiagnostic',
  LaboratoryService = 'LaboratoryService',
}

export enum PrescriptionStatusFilters {
  All = 'All',
  WaitPlanning = 'WaitPlanning',
  Planned = 'Planned',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  WillNotDo = 'WillNotDo',
}

export enum GuaranteeStatusFilters {
  All = 'All',
  WaitProcessing = 'WaitProcessing',
  Guaranteed = 'Guaranteed',
  NotGuaranteed = 'NotGuaranteed',
}

export interface PrescriptionsFilters {
  search: string;
  prescriptionType: PrescriptionTypeFilters;
  planningStatus: PrescriptionStatusFilters;
  guaranteeStatus: GuaranteeStatusFilters;
  historyStatus: PrescriptionHistoryStatus;
}

export const initialPrescriptionsState: PrescriptionsState = {
  prescriptionSubmitted: false,
  prescriptionDraftSubmitted: false,
  prescriptionSaved: false,
  prescriptionEdited: null,
  prescriptionDeleted: null,
  initRequired: true,
  guaranteesFilters: {
    search: '',
    prescriptionType: PrescriptionTypeFilters.All,
    planningStatus: PrescriptionStatusFilters.All,
    guaranteeStatus: GuaranteeStatusFilters.All,
    historyStatus: PrescriptionHistoryStatus.Active,
  },
  targetPrescription: null,
  count: 0,
  page: 1,
  pageSize: 10,
  hasNextPage: true,
  hasPreviousPage: false,
  guarantees: [],
  draftsProcessing: false,
  loading: false,
  guaranteesFetching: false,
};
